/* global axios */
import ApiClient from './ApiClient';

class ConversationViewersAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/viewers`);
  }

  touch(conversationId) {
    return axios.post(`${this.url}/${conversationId}/viewers`);
  }

  leave(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/viewers`);
  }
}

export default new ConversationViewersAPI();
